'use client';
import React, { useState } from 'react';

interface SearchViewProps {
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
  onSearch?: (value: string) => void;
  leftIcon?: string;
  rightIcon?: string;
  disabled?: boolean;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const SearchView: React.FC<SearchViewProps> = ({
  placeholder = "Search",
  value = "",
  onChange,
  onSearch,
  leftIcon = "/images/img_search.svg",
  rightIcon,
  disabled = false,
  className = "",
  size = "md"
}) => {
  const [inputValue, setInputValue] = useState(value);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setInputValue(newValue);
    onChange?.(newValue);
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onSearch?.(inputValue);
    }
  };

  const handleSearchClick = () => {
    onSearch?.(inputValue);
  };

  const sizes = {
    sm: 'px-2 py-1.5 text-xs sm:px-3 sm:py-2 sm:text-sm',
    md: 'px-3 py-2 text-sm sm:px-4 sm:py-2.5 sm:text-base',
    lg: 'px-4 py-3 text-base sm:px-5 sm:py-3.5 sm:text-lg'
  };

  const iconSizes = {
    sm: 'w-3 h-3 sm:w-4 sm:h-4',
    md: 'w-4 h-4 sm:w-5 sm:h-5',
    lg: 'w-5 h-5 sm:w-6 sm:h-6'
  };

  return (
    <div data-component-id="src/components/ui/SearchView.tsx:58:4" data-component-path="src/components/ui/SearchView.tsx" data-component-line="58" data-component-file="SearchView.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`relative flex items-center w-full ${className}`}>
      {leftIcon && (
        <div data-component-id="src/components/ui/SearchView.tsx:60:8" data-component-path="src/components/ui/SearchView.tsx" data-component-line="60" data-component-file="SearchView.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20left-2%20sm%3Aleft-3%20flex%20items-center%20pointer-events-none%22%7D" className="absolute left-2 sm:left-3 flex items-center pointer-events-none">
          <img data-component-id="src/components/ui/SearchView.tsx:61:10" data-component-path="src/components/ui/SearchView.tsx" data-component-line="61" data-component-file="SearchView.tsx" data-component-name="img" data-component-content="%7B%22elementName%22%3A%22img%22%2C%22src%22%3A%22%5Bvar%3AleftIcon%5D%22%2C%22alt%22%3A%22Search%22%7D"
            src={leftIcon}
            alt="Search"
            className={`${iconSizes[size]} opacity-60`}
          />
        </div>
      )}

      <input data-component-id="src/components/ui/SearchView.tsx:69:6" data-component-path="src/components/ui/SearchView.tsx" data-component-line="69" data-component-file="SearchView.tsx" data-component-name="input" data-component-content="%7B%22elementName%22%3A%22input%22%2C%22type%22%3A%22text%22%2C%22value%22%3A%22%5Bvar%3AinputValue%5D%22%7D"
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        onKeyPress={handleKeyPress}
        placeholder={placeholder}
        disabled={disabled}
        className={`
          w-full
          ${leftIcon ? 'pl-8 sm:pl-10' : 'pl-3 sm:pl-4'}
          ${rightIcon ? 'pr-8 sm:pr-10' : 'pr-3 sm:pr-4'}
          ${sizes[size]}
          bg-transparent
          border-0
          text-white-transparent
          placeholder-white-transparent
          focus:outline-none
          focus:ring-0
          transition-all
          duration-200
          ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
        `.trim().replace(/\s+/g, ' ')}
      />

      {rightIcon && (
        <button data-component-id="src/components/ui/SearchView.tsx:94:8" data-component-path="src/components/ui/SearchView.tsx" data-component-line="94" data-component-file="SearchView.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22absolute%20right-2%20sm%3Aright-3%20flex%20items-center%20hover%3Aopacity-80%20transition-opacity%22%7D"
          onClick={handleSearchClick}
          disabled={disabled}
          className="absolute right-2 sm:right-3 flex items-center hover:opacity-80 transition-opacity"
        >
          <img data-component-id="src/components/ui/SearchView.tsx:99:10" data-component-path="src/components/ui/SearchView.tsx" data-component-line="99" data-component-file="SearchView.tsx" data-component-name="img" data-component-content="%7B%22elementName%22%3A%22img%22%2C%22src%22%3A%22%5Bvar%3ArightIcon%5D%22%2C%22alt%22%3A%22Search%22%7D"
            src={rightIcon}
            alt="Search"
            className={`${iconSizes[size]} opacity-60`}
          />
        </button>
      )}
    </div>
  );
};

export default SearchView;